import { UserAddress } from '../models/User';

/** True when street, city, state, and ZIP are all non-empty. */
export function isAddressComplete(
  address: UserAddress | null | undefined | unknown
): boolean {
  if (!address || typeof address !== 'object') return false;
  const value = address as UserAddress;
  return !!(
    (value.line1 || '').toString().trim() &&
    (value.city || '').toString().trim() &&
    (value.state || '').toString().trim() &&
    (value.postalCode || '').toString().trim()
  );
}
